import React, { useEffect } from "react";
import { makeStyles, styled, TableCell, TableRow } from "@material-ui/core";

import { handleNumber } from "../../../../../../../method/displayData";

let useStyles = makeStyles((theme) => ({
    root: {
        width: "35%",
        minWidth: "33%",
        minHeight: "25vh",
        overflow: "auto",
        backgroundColor: "white",
        padding: 15,
        borderRadius: 5,
        border: "none",
        [theme.breakpoints.down("sm")]: {
            width: "90%",
            maxHeight: "80vh",
        },
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        overflow: "auto",
    },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
        backgroundColor: "#F2F4F6",
        // backgroundColor: "rgba(11,23,66,0.2)",
        cursor: 'pointer',
        color: 'rgb(11,23,66)',
        "&:hover": {
            backgroundColor: "rgba(11,23,66,0.1)",
        }
    },
    "&:nth-of-type(odd)": {
        cursor: 'pointer',
        // backgroundColor: "#F2F4F6",
        // backgroundColor: "rgba(11,23,66,0.2)",
        "&:hover": {
            // backgroundColor:'red',
            backgroundColor: "rgba(11,23,66,0.1)",
        }
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));


export default function Index({ info, index, handleLink, stock, setStock }) {

    let classes = useStyles();
    const [flag, setFlag] = React.useState(false);

    let handelData = (flag) => {
        if (!flag) {
            removeData(
                () => setFlag(flag)
            )
        }
        if (flag) {
            insertData(
                () => setFlag(flag)
            )
        }
    }

    const insertData = (cb) => {

        let data = info;
        setStock(prev => ({
            [data?.id]: data,
            ...prev
        }))

        let callBack = cb
        callBack()

    }

    const removeData = (cb) => {
        let data = info;


        let obj = {}
        Object.keys(stock)
            .forEach((itemKeys) => {
                if (itemKeys !== data?.id) {
                    obj[itemKeys] = stock[itemKeys]
                }
            })

        setStock(obj)

        let callBack = cb
        callBack()
    }

    return (
        <>
            <StyledTableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={index}
                style={{ height: 60 }}
            >
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.commodity_detail?.persianName}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"ltr"}
                >
                    {handleNumber(info?.body?.minimum_price)}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"ltr"}
                >
                    {handleNumber(info?.body?.maximum_price)}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"ltr"}
                >
                    {handleNumber(info?.body?.offer_base_price)}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"ltr"}
                >
                    {info?.body?.offer_volume}
                </TableCell>
                <TableCell
                    align="center"
                >
                    <img src="/assets/icons/delete.svg" alt=""
                        onClick={() => {
                            handelData(false);
                        }}

                    />
                </TableCell>
            </StyledTableRow>
        </>
    )
}

